var reactionGroupStyles = {
  root: function root() {
    return {};
  },
  reaction: function reaction(_ref) {
    var v = _ref.variables;
    return {
      ':not(:last-child)': {
        marginRight: v.reactionSpacing
      }
    };
  }
};
export default reactionGroupStyles;
//# sourceMappingURL=reactionGroupStyles.js.map
